import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import DataTable from "./DataTable";
import {CSVLink} from 'react-csv';

function TableCard() {

  const [data, setData] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState([])
  const [locationCriteria, setLocationCriteria] = useState([])
  const [senderCriteria, setSenderCriteria] = useState([])
  const [tagsCriteria, setTagsCriteria] = useState([])
  const [startDate, setStartDate] = useState([])
  const [endDate, setEndDate] = useState([])
  
  

  let all_files = []

  // const date = new Date()
  // const today = date.getFullYear() + "-" + (parseInt(date.getMonth())+1).toLocaleString('en-US', {
  //   minimumIntegerDigits: 2,
  //   useGrouping: false
  // }) + "-" + date.getDate().toLocaleString('en-US', {
  //   minimumIntegerDigits: 2,
  //   useGrouping: false
  // })

  
  useEffect(() => {
    axios("https://cvkdl78x74.execute-api.us-east-1.amazonaws.com/production/bdp_receipts/")
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  function getLocationKeys() {
    const unique = [...new Set(data.map(dataPoint => dataPoint.location))];
    let temp = []
    for (let uni of unique){
      
      temp.push({
        content: uni,
        isChecked: false})
    }
    return temp
  }

  function sumPrices(input){
    let sum = 0
    for (let item of input){
      sum += item.price
    }
    return sum.toFixed(2)
  }
  function search(rows){
    function filterLocation(rows, location){
      // console.log(location)
      return(
      rows.filter((row) => 
        row["location"].toString().indexOf(location) > -1
        )
      )
    }
    function filterSender(rows, sender){
      return(
        rows.filter((row) => 
          row["sender"].toString().indexOf(sender) > -1
          )
        )
      }
    function filterTags(rows, item){
      return(
        rows.filter((row) => 
          row["tag_string"].toString().indexOf(item) > -1
          )
        )
      }
    function filterStartDate(rows){
      const start = new Date(startDate)
      start.setUTCHours(start.getTimezoneOffset()/60)
      return(
        rows.filter((row) =>
            start <= new Date(row["date"])
        )
      )
    }
    function filterEndDate(rows){
      const end = new Date((endDate))
      console.log("BEFORE",end)
      end.setUTCHours(end.getTimezoneOffset()/60)
      end.setDate(end.getDate() + 1)
      console.log(end)
    
      return(
        rows.filter((row) =>
            new Date(row["date"]) <= end
        )
      )
    }
    function filterPrice(rows){
      return(
        rows.filter((row) =>
            !!row["price"]
        )
      )
    }
    let outputData = []
    // let inputData = rows
      // console.log(locationCriteria)
      let temp = []
      for (let location of locationCriteria){
        temp = [...temp,...filterLocation(rows, location)]
      }
      if (locationCriteria.length < 1){
        // console.log("no criteria")
        temp = rows
      }
      // console.log("temp",temp)
      outputData = temp
      temp = []
      for (let sender of senderCriteria){
        temp = [...temp, ...filterSender(outputData, sender)]
      }
      if (senderCriteria.length < 1){
        // console.log("no criteria")
        temp = outputData
      }
      // console.log("temp1",temp)
      outputData = temp
      temp = []
    for (let tag of tagsCriteria){
      temp = [...temp, ...filterTags(outputData, tag)]

    }
    if (tagsCriteria.length < 1){
      // console.log("no criteria")
      temp = outputData
    }
    // console.log("temp2",temp)
    outputData = temp
    // console.log(outputData)
    if (searchCriteria.includes("include_price")){
      outputData = filterPrice(outputData)
    }
    if(startDate.length > 0){
      console.log(startDate)
      outputData = filterStartDate(outputData)
    }
    if(!!endDate.length > 0){
      outputData = filterEndDate(outputData)
      console.log(endDate)
    }
    
    return [...new Set(outputData)]
  }
  
  // function search(rows){
  //   let outData
  //   if (searchCriteria.includes("exclusive search")){
  //     outData = exclusiveSearch(rows)
  //   }
  //   else{
  //     outData = inclusiveSearch(rows)
  //   }
  //   return outData
  // }

  function getSenderKeys() {
    const unique = [...new Set(data.map(dataPoint => dataPoint.sender))];
    let temp = []
    for (let uni of unique){
      temp.push({
        content: uni,
        isChecked: false})
    }
    return temp
  }
  function getKeysKeys() {
        
    let temp = []
    let items = []

    let unique = [...new Set(data.map(dataPoint => dataPoint.tag_array))]
    for (let uni of unique){
      let temp_items = String(uni).split(",")
      for (let item of temp_items){
        items.push(item)
      }
    }
    unique = new Set(items)
    for (let uni of unique){
      temp.push(uni)
    }

    return temp.sort()
  }

  const convertArrayElements = () => {
    for (let dataPoint of data) {
      let tag_string = ``
      let tag_array = []
      dataPoint.date = dataPoint.date.split(" ").slice(0,5).join(" ")
      // dataPoint.price = parseFloat(dataPoint.price)
      for (let tag of Object.keys(dataPoint.tags)){
        all_files.push(tag)
        if (tag_string === ``){
          tag_string = tag
          tag_array.push(tag)
        }
        else{
          tag_string = tag_string + `, ` + tag
          tag_array.push(tag)
        }
      }
      dataPoint.tag_string = tag_string
      dataPoint.tag_array = tag_array

      let file_string = ``
      let file_array = []
      for (let file of dataPoint.filename){
        if (file_string === ``){
          file_string = file
          file_array.push(file)
        }
        else{
          file_string = file_string + `, ` + file
          file_array.push(file)
        }
      }
      dataPoint.file_string = file_string
      dataPoint.file_array = file_array
      // console.log(tag_array)
    }
  }

  

  return (
    <BdbFinances>  
    <div className="bdp_data">
      {convertArrayElements()}
      <div className="account">
      <h1>
      Account:
      </h1>
      { getLocationKeys().map((item, idx) => {
            return(
             <>   
            <input 
                id={item.content} 
                key={item.content}
                value={item.content}  
                type='checkbox' 
                placeholder={item.content}
                checked={locationCriteria.includes(item.content)}
                onChange={(e) => {
                  const checked = locationCriteria.includes(item.content)
                  setLocationCriteria((prev) =>
                  checked
                    ? prev.filter((sc) => sc !== item.content)
                    : [...prev, item.content])
                }
              }
            />
            <label htmlFor={item.content}>
                {`   ` + item.content + `   `} 
            </label>
            </>
            )
        }) }      
      </div>
      <div className="reporter">
      <h1>Reporter:</h1>

{ getSenderKeys().map((item, idx) => {
      return(
       <>   
      <input 
          id={item.content} 
          key={item.content}
          value={item.content}  
          type='checkbox' 
          placeholder={item.content}
          checked={senderCriteria.includes(item.content)}
          onChange={(e) => {
            const checked = senderCriteria.includes(item.content)
            setSenderCriteria((prev) =>
            checked
              ? prev.filter((sc) => sc !== item.content)
              : [...prev, item.content])
          }
        }
      />
      <label htmlFor={item.content}>
          {`   ` + item.content + `   `} 
      </label>
      </>
      )
  }) }    
      </div>
      <div className="tags">
      <h1>Tags:</h1>
      { getKeysKeys().map((item, idx) => {

            return(
              <>
            <input 
                id={item} 
                key={item}
                value={item}  
                type='checkbox' 
                placeholder={item}
                checked={tagsCriteria.includes(item)}
                onChange={() => {
                  // console.log(item)
                  const checked = tagsCriteria.includes(item)
                  setTagsCriteria((prev) =>
                  checked
                    ? prev.filter((sc) => sc !== item)
                    : [...prev, item])
                }
              }
            />
             <label htmlFor={item}>
                {`   ` + item + `   `} 
            </label>
            </>
            )
        }) }   
      </div>
     <div className="daterange">
     <h1>Date Range:</h1>
      <div> 
      <label htmlFor={"start_date"}>
                {"Enter Starting Date:"} 
            </label>
            </div>
            <div>
      <input 
                id={"start_date"} 
                key={"start_date"}
                value={startDate}  
                type='date' 
                checked={searchCriteria.includes("start_date")}
                onChange={(e) => {
                  console.log(e.target.value)
                  setStartDate(e.target.value)
                }
              }
            />
          </div>
          <div>
            <label htmlFor={"end_date"}>
                {"Enter Ending Date:"} 
            </label>
            </div>
            <div>
            <input 
                id={"end_date"} 
                key={"end_date"}
                value={endDate}  
                type='date' 
                placeholder={"end_date"}
                onChange={(e) => {
                  setEndDate(e.target.value)
                }
              }
            />
            </div>
     </div>
            <div className="misc">
         <h1>Misc:</h1>

      <input 
                id={"include_price"} 
                key={"include_price"}
                value={"include_price"}  
                type='checkbox' 
                placeholder={"include_price"}
                checked={searchCriteria.includes("include_price")}
                onChange={(e) => {
                  const checked = searchCriteria.includes("include_price")
                  setSearchCriteria((prev) =>
                  checked
                    ? prev.filter((sc) => sc !== "include_price")
                    : [...prev, "include_price"])
                }
              }
            />
            <label htmlFor={"include_price"}>
                {"Must include price"} 
            </label>

            <input 
                id={"show_total"} 
                key={"show_total"}
                value={"show_total"}  
                type='checkbox' 
                placeholder={"show_total"}
                checked={searchCriteria.includes("show_total")}
                onChange={(e) => {
                  const checked = searchCriteria.includes("show_total")
                  setSearchCriteria((prev) =>
                  checked
                    ? prev.filter((sc) => sc !== "show_total")
                    : [...prev, "show_total"])
                }
              }
            />
            <label htmlFor={"show_total"}>
                {"Show Total"} 
            </label>

            <CSVLink className="button" data={search(data)} target="_blank"> Download CSV</CSVLink> 
            </div>
            {searchCriteria.includes("show_total") &&
            <h1 className="total">
              Total: ${sumPrices(search(data))} 
            </h1>
            }
      <DataTable data = {search(data)} />
    </div>
    </BdbFinances>  
  );
}

export default TableCard;

const BdbFinances = styled.div`
  text-align:left;
  /* margin-left: 5px; */
  input {
         /* padding: 20px; */
         margin-left:10px;
      }
  .total{
    color:orange;
    padding: 5px;
  }
  .account {
      display:block;
      /* margin: 5px; */
      border-top:solid 2px var(--font-light-color);
      border-bottom:solid 2px var(--font-light-color);
      padding: 2.4px;
  }
  .reporter {
      display:block;
      /* margin: 5px; */
      border-top:solid 2px var(--font-light-color);
      border-bottom:solid 2px var(--font-light-color);
      padding: 2.4px;
  }
    .tags {
      display:block;
      /* margin: 5px; */
      border-top:solid 2px var(--font-light-color);
      border-bottom:solid 2px var(--font-light-color);
      padding: 2.4px;
    }
    .daterange {
      display:block;
      /* margin: 5px; */
      border-top:solid 2px var(--font-light-color);
      border-bottom:solid 2px var(--font-light-color);
      padding: 2.4px;
  }
    .misc {
      display:block;
      /* margin: 5px; */
      border-top:solid 2px var(--font-light-color);
      border-bottom:solid 2px var(--font-light-color);
      padding: 2.4px;

      .button{
        position:relative;
        cursor:pointer;
        float:right;
        right:3rem;
        bottom:1.25rem;
        /* justify-content:right; */
        text-align: center;
        padding: .5rem;
        border-radius: .5rem;
        background-color: var(--primary-color);
      }
    }
`;